import { render, staticRenderFns } from "./PostCodesTile.vue?vue&type=template&id=671f3898&scoped=true&"
import script from "./PostCodesTile.vue?vue&type=script&lang=ts&"
export * from "./PostCodesTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671f3898",
  null
  
)

export default component.exports